import { createGlobalStyle } from "styled-components";
import { colors, sizes } from "./variables.styled";
// Design System: Fontes devem ser carregadas pela aplicação consumidora
// ou via um componente separado de FontsLoader se necessário.
// Removida dependência de getAppConfig e frontendPath do AEM.
export const fontFamilies = {
    primary: "'Figtree', sans-serif",
    secondary: "'Figtree', sans-serif",
};
export const fontWeights = {
    regular: 400,
    medium: 500,
    bold: 700,
};
export const textColors = {
    primary: colors.neutral800,
    secondary: colors.neutral600,
    accent: colors.brand500,
    neutral: colors.neutral500,
};
export const breakpoints = {
    mobile: `${sizes.mobile}px`,
    tablet: `${sizes.tablet}px`,
    desktop: `${sizes.desktop}px`,
    // desktopLarge: `${sizes.desktopLarge}px`,
};
export const media = {
    mobile: `@media (min-width: ${breakpoints.mobile})`,
    tablet: `@media (min-width: ${breakpoints.tablet})`,
    desktop: `@media (min-width: ${breakpoints.desktop})`,
    // desktopLarge: `@media (min-width: ${breakpoints.desktopLarge})`,
};
export const typography = {
    display1: {
        fontFamily: fontFamilies.secondary,
        fontWeight: fontWeights.bold,
        color: textColors.primary,
        fontSize: "40px",
        lineHeight: "48px",
        [media.tablet]: { fontSize: "48px", lineHeight: "56px" },
        [media.desktop]: { fontSize: "64px", lineHeight: "72px" },
    },
    display2: {
        fontFamily: fontFamilies.secondary,
        fontWeight: fontWeights.bold,
        color: textColors.primary,
        fontSize: "32px",
        lineHeight: "40px",
        [media.tablet]: { fontSize: "40px", lineHeight: "48px" },
        [media.desktop]: { fontSize: "48px", lineHeight: "56px" },
    },
    headline1: {
        fontFamily: fontFamilies.primary,
        fontWeight: fontWeights.bold,
        color: textColors.primary,
        fontSize: "32px",
        lineHeight: "36px",
        [media.tablet]: { fontSize: "40px", lineHeight: "48px" },
        [media.desktop]: { fontSize: "48px", lineHeight: "56px" },
    },
    headline2: {
        fontFamily: fontFamilies.primary,
        fontWeight: fontWeights.bold,
        color: textColors.primary,
        fontSize: "28px",
        lineHeight: "32px",
        [media.tablet]: { fontSize: "32px", lineHeight: "36px" },
        [media.desktop]: { fontSize: "40px", lineHeight: "52px" },
    },
    headline3: {
        fontFamily: fontFamilies.primary,
        fontWeight: fontWeights.bold,
        color: textColors.primary,
        fontSize: "24px",
        lineHeight: "32px",
        [media.tablet]: { fontSize: "28px", lineHeight: "32px" },
        [media.desktop]: { fontSize: "32px", lineHeight: "42px" },
    },
    headline4: {
        fontFamily: fontFamilies.primary,
        fontWeight: fontWeights.bold,
        color: textColors.primary,
        fontSize: "20px",
        lineHeight: "28px",
        [media.tablet]: { fontSize: "24px", lineHeight: "32px" },
        [media.desktop]: { fontSize: "24px", lineHeight: "32px" },
    },
    headline5: {
        fontFamily: fontFamilies.primary,
        fontWeight: fontWeights.bold,
        color: textColors.primary,
        fontSize: "18px",
        lineHeight: "24px",
        [media.tablet]: { fontSize: "20px", lineHeight: "28px" },
        [media.desktop]: { fontSize: "20px", lineHeight: "28px" },
    },
    headline6: {
        fontFamily: fontFamilies.primary,
        fontWeight: fontWeights.bold,
        color: textColors.primary,
        fontSize: "14px",
        lineHeight: "18px",
        [media.tablet]: { fontSize: "16px", lineHeight: "20px" },
        [media.desktop]: { fontSize: "18px", lineHeight: "24px" },
    },
    subtitle1: {
        fontFamily: fontFamilies.primary,
        fontWeight: fontWeights.medium,
        color: textColors.primary,
        fontSize: "20px",
        lineHeight: "28px",
        [media.tablet]: { fontSize: "24px", lineHeight: "32px" },
        [media.desktop]: { fontSize: "24px", lineHeight: "32px" },
    },
    subtitle2: {
        fontFamily: fontFamilies.primary,
        fontWeight: fontWeights.medium,
        color: textColors.primary,
        fontSize: "18px",
        lineHeight: "28px",
        [media.tablet]: { fontSize: "20px", lineHeight: "28px" },
        [media.desktop]: { fontSize: "20px", lineHeight: "28px" },
    },
    subtitle3: {
        fontFamily: fontFamilies.primary,
        fontWeight: fontWeights.medium,
        color: textColors.primary,
        fontSize: "14px",
        lineHeight: "20px",
        [media.tablet]: { fontSize: "18px", lineHeight: "24px" },
        [media.desktop]: { fontSize: "18px", lineHeight: "24px" },
    },
    body1: {
        fontFamily: fontFamilies.primary,
        fontWeight: fontWeights.regular,
        color: textColors.primary,
        fontSize: "18px",
        lineHeight: "24px",
        [media.tablet]: { fontSize: "18px", lineHeight: "28px" },
        [media.desktop]: { fontSize: "18px", lineHeight: "28px" },
    },
    body1Highlight: {
        fontFamily: fontFamilies.primary,
        fontWeight: fontWeights.bold,
        color: textColors.primary,
        fontSize: "18px",
        lineHeight: "24px",
        [media.tablet]: { fontSize: "18px", lineHeight: "28px" },
        [media.desktop]: { fontSize: "18px", lineHeight: "28px" },
    },
    body2: {
        fontFamily: fontFamilies.primary,
        fontWeight: fontWeights.regular,
        color: textColors.primary,
        fontSize: "16px",
        lineHeight: "24px",
        [media.tablet]: { fontSize: "16px", lineHeight: "24px" },
        [media.desktop]: { fontSize: "16px", lineHeight: "24px" },
    },
    body2Highlight: {
        fontFamily: fontFamilies.primary,
        fontWeight: fontWeights.bold,
        color: textColors.primary,
        fontSize: "16px",
        lineHeight: "24px",
        [media.tablet]: { fontSize: "16px", lineHeight: "24px" },
        [media.desktop]: { fontSize: "16px", lineHeight: "24px" },
    },
    body3: {
        fontFamily: fontFamilies.primary,
        fontWeight: fontWeights.regular,
        color: textColors.primary,
        fontSize: "14px",
        lineHeight: "20px",
        [media.tablet]: { fontSize: "14px", lineHeight: "20px" },
        [media.desktop]: { fontSize: "14px", lineHeight: "20px" },
    },
    body3Highlight: {
        fontFamily: fontFamilies.primary,
        fontWeight: fontWeights.bold,
        color: textColors.primary,
        fontSize: "14px",
        lineHeight: "20px",
        [media.tablet]: { fontSize: "14px", lineHeight: "20px" },
        [media.desktop]: { fontSize: "14px", lineHeight: "20px" },
    },
    body4: {
        fontFamily: fontFamilies.primary,
        fontWeight: fontWeights.regular,
        color: textColors.primary,
        fontSize: "12px",
        lineHeight: "18px",
        [media.tablet]: { fontSize: "12px", lineHeight: "18px" },
        [media.desktop]: { fontSize: "12px", lineHeight: "18px" },
    },
    body4Highlight: {
        fontFamily: fontFamilies.primary,
        fontWeight: fontWeights.regular,
        color: textColors.primary,
        fontSize: "12px",
        lineHeight: "18px",
        [media.tablet]: { fontSize: "12px", lineHeight: "18px" },
        [media.desktop]: { fontSize: "12px", lineHeight: "18px" },
    },
    quote: {
        fontFamily: fontFamilies.primary,
        fontStyle: "italic",
        fontWeight: fontWeights.regular,
        color: textColors.primary,
        fontSize: "16px",
        lineHeight: "24px",
        [media.tablet]: { fontSize: "16px", lineHeight: "24px" },
        [media.desktop]: { fontSize: "16px", lineHeight: "24px" },
    },
    legend: {
        fontFamily: fontFamilies.primary,
        fontWeight: fontWeights.regular,
        color: textColors.primary,
        fontSize: "10px",
        lineHeight: "16px",
        [media.tablet]: { fontSize: "12px", lineHeight: "18px" },
        [media.desktop]: { fontSize: "12px", lineHeight: "18px" },
    },
    legendHighlight: {
        fontFamily: fontFamilies.primary,
        fontWeight: fontWeights.bold,
        color: textColors.primary,
        textTransform: "uppercase",
        fontSize: "10px",
        lineHeight: "16px",
        [media.tablet]: { fontSize: "12px", lineHeight: "18px" },
        [media.desktop]: { fontSize: "12px", lineHeight: "18px" },
    },
    buttonLarge: {
        fontFamily: fontFamilies.primary,
        fontWeight: fontWeights.bold,
        color: textColors.secondary,
        fontSize: "18px",
        lineHeight: "24px",
        [media.tablet]: { fontSize: "18px", lineHeight: "24px" },
        [media.desktop]: { fontSize: "18px", lineHeight: "24px" },
    },
    buttonMedium: {
        fontFamily: fontFamilies.primary,
        fontWeight: fontWeights.bold,
        color: textColors.secondary,
        fontSize: "16px",
        lineHeight: "24px",
        [media.tablet]: { fontSize: "16px", lineHeight: "24px" },
        [media.desktop]: { fontSize: "16px", lineHeight: "24px" },
    },
    buttonSmall: {
        fontFamily: fontFamilies.primary,
        fontWeight: fontWeights.bold,
        color: textColors.secondary,
        fontSize: "14px",
        lineHeight: "24px",
        [media.tablet]: { fontSize: "14px", lineHeight: "24px" },
        [media.desktop]: { fontSize: "14px", lineHeight: "24px" },
    },
    buttonExtraSmall: {
        fontFamily: fontFamilies.primary,
        fontWeight: fontWeights.bold,
        color: textColors.secondary,
        fontSize: "10px",
        lineHeight: "16px",
        [media.tablet]: { fontSize: "10px", lineHeight: "16px" },
        [media.desktop]: { fontSize: "12px", lineHeight: "18px" },
    },
    linkLarge: {
        fontFamily: fontFamilies.primary,
        fontWeight: fontWeights.bold,
        color: textColors.secondary,
        fontSize: "16px",
        lineHeight: "24px",
        [media.tablet]: { fontSize: "18px", lineHeight: "24px" },
        [media.desktop]: { fontSize: "18px", lineHeight: "24px" },
    },
    linkLargeUnderlined: {
        fontFamily: fontFamilies.primary,
        fontWeight: fontWeights.bold,
        color: textColors.secondary,
        textDecoration: "underline",
        fontSize: "16px",
        lineHeight: "24px",
        [media.tablet]: { fontSize: "18px", lineHeight: "24px" },
        [media.desktop]: { fontSize: "18px", lineHeight: "24px" },
    },
    linkSmall: {
        fontFamily: fontFamilies.primary,
        fontWeight: fontWeights.bold,
        color: textColors.secondary,
        fontSize: "14px",
        lineHeight: "20px",
        [media.tablet]: { fontSize: "14px", lineHeight: "20px" },
        [media.desktop]: { fontSize: "14px", lineHeight: "20px" },
    },
    linkSmallUnderlined: {
        fontFamily: fontFamilies.primary,
        fontWeight: fontWeights.bold,
        color: textColors.secondary,
        textDecoration: "underline",
        fontSize: "14px",
        lineHeight: "20px",
        [media.tablet]: { fontSize: "14px", lineHeight: "20px" },
        [media.desktop]: { fontSize: "14px", lineHeight: "20px" },
    },
    linkIcon: {
        display: "inline-flex",
        alignItems: "center",
        padding: "4px",
        gap: "4px",
        position: "relative",
    },
    anchorTab: {
        fontFamily: fontFamilies.primary,
        fontWeight: fontWeights.regular,
        color: textColors.primary,
        fontSize: "14px",
        lineHeight: "20px",
        [media.tablet]: { fontSize: "14px", lineHeight: "20px" },
        [media.desktop]: { fontSize: "16px", lineHeight: "24px" },
    },
};
export const Typography = createGlobalStyle `
	div,
	li,
	section,
	article,
	main,
	nav,
	p {
		font-family: 'Figtree', Arial, Helvetica, sans-serif;
		font-style: normal;
		font-size: 16px;
		line-height: 150%;
	}

	html.inverted img {
		filter: invert(1);
	}

	* {
		&:focus-visible {
			outline: none;
			border-radius: 8px;
			-webkit-box-shadow: 0 0 0 3px ${colors.brand100};
			-moz-box-shadow: 0 0 0 3px ${colors.brand100};
			box-shadow: 0 0 0 3px ${colors.brand100};
		}
	}
`;
//# sourceMappingURL=typography.style.js.map